import { render, staticRenderFns } from "./JuniorFeedback.vue?vue&type=template&id=6f08ca74"
import script from "./JuniorFeedback.vue?vue&type=script&lang=js"
export * from "./JuniorFeedback.vue?vue&type=script&lang=js"
import style0 from "./JuniorFeedback.vue?vue&type=style&index=0&id=6f08ca74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports